<style lang="scss"></style>
<style lang="scss" scoped="scoped"></style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 14px;display: flex;justify-content: space-between;" :style="{ background: $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#1D1D24' : '#000466' }">
    <div style="background:rgba(18, 18, 18, 1);height: 100%;width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;" :style="{ background: $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#121212' : '#060A6D', 'border-color': $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#636363' : '#3283FC', 'box-shadow': $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? 'none' : '-5px -5px 30px 0px #4075FF40 inset' }">
      <div style="color: rgba(255, 58, 94, 1);font-weight: bold;font-size: 16px;margin-bottom: 4px;">
        {{ $t('shengchanyujing') }}
      </div>
      <div style="display: flex;justify-content: center;align-items: center;">
        <span style="color: rgba(255, 58, 94, 1);font-weight: 700;font-size: 30px;">{{ count1 == null ? 0 : count1 }}</span>
      </div>
    </div>
    <div style="background:rgba(18, 18, 18, 1);height: 100%;width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;margin-left: 10px;" :style="{ background: $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#121212' : '#060A6D', 'border-color': $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#636363' : '#3283FC', 'box-shadow': $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? 'none' : '-5px -5px 30px 0px #4075FF40 inset' }">
      <div style="color: rgba(255, 200, 58, 1);font-weight: bold;font-size: 16px;margin-bottom: 4px;">
        {{ $t('gongkuanyujing') }}
      </div>
      <div style="display: flex;justify-content: center;align-items: center;">
        <span style="color: rgba(255, 200, 58, 1);font-weight: 700;font-size: 30px;">{{ count2 == null ? 0 : count2 }}</span>
      </div>
    </div>
    <div style="background:rgba(18, 18, 18, 1);height: 100%;width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;margin-left: 10px;" :style="{ background: $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#121212' : '#060A6D', 'border-color': $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#636363' : '#3283FC', 'box-shadow': $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? 'none' : '-5px -5px 30px 0px #4075FF40 inset' }">
      <div style="color: rgba(255, 58, 94, 1);font-weight: bold;font-size: 16px;margin-bottom: 4px;">
        {{ $t('weixiuyujing') }}
      </div>
      <div style="display: flex;justify-content: center;align-items: center;">
        <span style="color: rgba(255, 58, 94, 1);font-weight: 700;font-size: 30px;">{{ count3 == null ? 0 : count3 }}</span>
      </div>
    </div>
    <div style="background:rgba(18, 18, 18, 1);height: 100%;width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;margin-left: 10px;" :style="{ background: $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#121212' : '#060A6D', 'border-color': $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#636363' : '#3283FC', 'box-shadow': $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? 'none' : '-5px -5px 30px 0px #4075FF40 inset' }">
      <div style="color: rgba(255, 200, 58, 1);font-weight: bold;font-size: 16px;margin-bottom: 4px;">
        {{ $t('canshuyujing') }}
      </div>
      <div style="display: flex;justify-content: center;align-items: center;">
        <span style="color: rgba(255, 200, 58, 1);font-weight: 700;font-size: 30px;">{{ count4 == null ? 0 : count4 }}</span>
      </div>
    </div>
    <div style="background:rgba(18, 18, 18, 1);height: 100%;width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;margin-left: 10px;" :style="{ background: $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#121212' : '#060A6D', 'border-color': $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? '#636363' : '#3283FC', 'box-shadow': $attrs.monitorSetting.MONITOR_MODEL_MANAGE_STYLE_TEMPLATE == 'black' ? 'none' : '-5px -5px 30px 0px #4075FF40 inset' }">
      <div style="color: rgba(255, 58, 94, 1);font-weight: bold;font-size: 16px;margin-bottom: 4px;">
        {{ $t('pingtaiyujing') }}
      </div>
      <div style="display: flex;justify-content: center;align-items: center;">
        <span style="color: rgba(255, 58, 94, 1);font-weight: 700;font-size: 30px;">{{ count5 == null ? 0 : count5 }}</span>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_model_manage_count',
  components: {},
  watch: {},
  data() {
    return {
      timer: null,
      count1: 0,
      count2: 0,
      count3: 0,
      count4: 0,
      count5: 0,
      count6: 0,
      count7: 0,
      count8: 0
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listData();
    }, 120000);
    this.listData();
  },
  mounted() {
    console.log('$attrs', this.$attrs);
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listData() {
      let response = await this.http.get('/web/warning/log/count', {
        params: {
          //orgId: this.$attrs.orgId,
        }
      });
      // productionWarning  生产
      this.count1 = response.data.productionWarning; // 生产
      this.count2 = response.data.operationWarning; // 工况
      this.count3 = response.data.maintenanceWarning; //维修
      this.count4 = response.data.parameterWarning; //参数
      this.count5 = response.data.platformWarning; //平台
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {}, 800);
    }
  }
};
</script>
